import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
import RequestPayment from "@/packages/WaasModules/Payments/component/RequestPayment.vue";
import TillPayments from "@/packages/WaasModules/Payments/component/TillPayments.vue";
import LipaFare from "@/packages/WaasModules/Payments/component/LipaFare.vue";

const PaymentRoutes =[
    {
        path: '/dashboard/waas/payments',
        component: DashboardLayout,
        children: [
            {
                path: 'request',
                component: RequestPayment,
                name: "RequestPayment",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'till',
                component: TillPayments,
                name: "TillPayments",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'lipa-fare',
                component: LipaFare,
                name: "LipaFare",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default PaymentRoutes;
